import getCachedRequest from './getCachedRequest'

const API = {
  /**
   * Gets from the API
   *
   * @param {String} url The endpoint URL
   * @returns {Object} API Response Object
   */
  async get(url) {
    const response = await fetch(url, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(res => res.json())
      .catch(error => ({ message: error }))

    return response
  },

  /**
   * Gets from the API or SessionStorage Cache
   *
   * @param {String} key Cache Key
   * @param {String} url The endpoint URL
   * @param {Boolean} ignoreCache Whether to bypass cache or not
   * @returns {Object} API Response Object
   */
  async getCached(key, url, ignoreCache = false) {
    const response = await getCachedRequest(
      key,
      [
        url,
        {
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      ],
      ignoreCache,
    )

    return response
  },

  /**
   * Post to the API
   *
   * @param {String} url The endpoint URL
   * @param {Object} data The Payload
   * @returns {Object} API Response Object
   */
  async post(url, data = {}) {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(res => res.json())
      .catch(error => ({ message: error }))

    return response
  },

  /**
   * Post to the API
   *
   * @param {String} url The endpoint URL
   * @param {FormData} formData The Payload
   * @returns {Object} API Response Object
   */
  async postForm(url, formData) {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    })
      .then(res => res.json())
      .catch(error => ({ message: error }))

    return response
  },
}

export default API
